// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VeeValidate, { Validator } from 'vee-validate';
import zh_TW from 'vee-validate/dist/locale/zh_TW';
import router from '@/router/router';
import store from '@/store/store';
import '@/filter/filter';
import '@/event-bus/eventBus';
import App from './App.vue';
import VueAnalytics from 'vue-analytics'
import Progress from 'vue-multiple-progress'
import auth from '@/auth/auth'
import {headerScript} from '@/util/headerScript'
import happyPackageApi from '@/api/happyPackage/happyPackageApi.js'

Vue.use(Progress)
Vue.config.productionTip = false;
Vue.use(VeeValidate, {
    fieldsBagName: 'formFields',
}, );
Validator.localize('zh_TW', zh_TW);

/* eslint-disable no-new */
var vm_app = new Vue({
    el: '#app',
    store,
    router,
    auth,
    components: { App },
    template: '<App/>',
    computed: {
        loginOut: function() { // computed property will be updated when async call resolves
            return this.$store.state.profile.visit;
        }
    },
    watch: { // watch changes here
        loginOut: function(newValue, oldValue) {
            if(newValue){
                // header
                this.loadBlockHtml("headerMenu",  process.env.HEADERMENU);
                // siteMap
                this.loadBlockHtml("siteMapContainer", process.env.SITEMAPCONTAINER);
                // footer
                this.loadBlockHtml("footerbox", process.env.FOOTERBOX);

                if(this.$store.state.profile.name){
                  // 判斷登入狀態去修改視圖
                  $('#loginStatusMobile').addClass('memberActive');
                  var tempHtml = $('#loginStatusMobile').html();
                  $('#loginStatusMobile').html(tempHtml.replace('用戶/會員登入', '用戶/會員登出'))

                  const logoutUrl = `javascript:logout("${process.env.CAS_LOGOUT_URL}?service=${encodeURIComponent(process.env.MAIN_PAGE)}");`;

                  $('#loginStatusMobile a')[0].href = logoutUrl;

                  $('#loginStatus').addClass('active');
                  $('#loginStatus').prop('title', '登出')
                  $('#loginStatus a')[0].href = logoutUrl;
                }
                
                //   haeder, footer, sitemap 載入後執行的 script
                // headerScript(); => script OpenCMS 會自己引入
                var el_gt_year = document.getElementById("gt_year");
                if (el_gt_year) {
                  el_gt_year.innerHTML = new Date().getFullYear();
                }
            }
        }
    },
    mounted() {},
    methods: {
        loadBlockHtml(id, url, data) {
          $.ajax({
            url: url,
            data: data,
            type: "POST",
            dataType: "text",
            async: false,
            success: function(html) {
              if(id === 'headerMenu'){
                html = '<header class="gt-header newHeader" data-spy="affix" data-offset-top="30">' + html + '</header>'
              }
              var htmlCode = $(html)
              $("#" + id).html(htmlCode);
            }
          });
        },
        async loadHappyPacakgeGroup() {

          const happyPackageGroupUrl = '/Service/#/HappyPackageGroup/';
          const happyPackageUrl = '/Service/#/HappyPackage/';


          const resp = await happyPackageApi.getHappyPackageGroupList();
          if (resp) {
            resp.happyPackageGroups.forEach(hpg => {
              const key = hpg.key;
              const title = hpg.title;

              let titleAHref = document.querySelector(`#${key}>a`);
              if (!titleAHref) {
                return;
              }
              titleAHref.href = happyPackageGroupUrl + key;
              titleAHref.title = title;
              
              let html = titleAHref.innerHTML;
              // 移除TAB與換行符
              html = html.replace(/\n|\t/g, '');
              // 分組HTML tag與純文字
              let tagArr = html.match(/\<.*?\>|.+/g);
              // 找出純文字部分並替換為實際標題
              tagArr.forEach((v, i, arr) => {
                const isHtmlTag = v.match(/^\<.*?\>$/);
                if (!isHtmlTag) {
                  tagArr[i] = title;
                }
              });
              
              // 更新HTML
              titleAHref.innerHTML = tagArr.join('');

              // happyPackage
              let ul = this.createElementFromHTML('<ul></ul>');
              if (hpg.happyPackages) {
                hpg.happyPackages.forEach((hp, i) => {
                  let li = this.createElementFromHTML(`<li><a href="${happyPackageUrl + hp.key}">${hp.title}</li>`);
                  if (hp == 0) {
                    li.addClass('active');
                  }
                  //console.log(li)
                  ul.appendChild(li);
                });
                //console.log(ul)
              }
              titleAHref.parentElement.append(ul)
              console.log(titleAHref)
            });

            /*
            let enteraiment = document.querySelector('#enteraiment');
            enteraiment.href = '123';
            enteraiment.append(this.createElementFromHTML('<ul></ul>'));
            console.log(enteraiment)
            let ilearning = document.querySelector('#i-learning');
            console.log(ilearning)
            let comic = document.querySelector('#comic');
            console.log(comic)
            let ring = document.querySelector('#ring');
            console.log(ring)
            */
          }
        },
        createElementFromHTML(htmlString) {
          var div = document.createElement('div');
          div.innerHTML = htmlString.trim();
        
          // Change this to div.childNodes to support multiple top-level nodes
          return div.firstChild; 
        }
      },
    created() {},

});

Vue.use(VueAnalytics, {
    id: ["UA-4860632-1", "UA-4860632-2"],
    disableScriptLoader: true, // 必须在html中完成初始化，這裡顯示禁止去下載ga腳本
    router, // 確保路由切換時可以自動統計
    autoTracking: {
        pageviewOnLoad: false,
        pageviewTemplate (route) {
            return {
              page: router.path,
              title: document.title,
              location: window.location.href
            }
        }
    }
})



// WEBPACK FOOTER //
// ./src/main.js